/**
 * O que a interface esconde enquanto a Dozy só recruta.
 * A flag em si vem do servidor; aqui só se decide o que deixa de se mostrar.
 */

const LIGACOES_MERCADO = new Set([
  '/dashboard?s=services',
  '/dashboard?s=requests',
  '/minha-casa',
  '/nearby-workers',
  '/appointments',
  '/disputes',
  '/premium',
  '/obras',
]);

export function ligacaoDeMercado(to) {
  if (!to) return false;
  const path = String(to).split('?')[0];
  if (LIGACOES_MERCADO.has(to) || LIGACOES_MERCADO.has(path)) return true;
  if (path === '/obras' || path.startsWith('/obras/')) return true;
  return false;
}

export function filtrarNavegacao(itens, recrutamento) {
  if (!recrutamento) return itens;
  return itens.filter((item) => item.product !== 'premium' && !ligacaoDeMercado(item.to));
}

/** Início, perfil e definições. Serviços e pedidos são o mercado. */
export function seccoesDoCliente(seccoes, recrutamento) {
  if (!recrutamento) return seccoes;
  const manter = new Set([null, 'profile', 'settings']);
  return seccoes.filter((s) => manter.has(s.id));
}

/** No registo da empresa a conta pessoal continua a ser de cliente. */
export function registoDeProfissional(recrutamento, paraEmpresa) {
  return Boolean(recrutamento) && !paraEmpresa;
}
